<template>
  <div class="items">
    <span>{{ item.keyword }}</span>
    <Button
      :to="{
        name: 'contentPlans',
        query: {
          keyword: item.keyword
        }
      }"
      size="w236"
      fsize="f12"
      variant="main"
    >
      記事構成案を作成する
    </Button>
  </div>
</template>

<script>
import Button from '@/components/Button';

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },

  components: {
    Button
  }
};
</script>
